import React, { PropsWithChildren } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider as ReduxProvider } from "react-redux";
import { Compose } from "@tomocredit/common-fe/components";
import { TimerProvider } from "components/common/wrappers/withTimer";
import { PopupProvider } from "components/common/wrappers/withPopup";
import { ChargebeeInstanceProvider } from "components/common/wrappers/withChargebeeApi";
import { BreakpointProvider } from "components/common/wrappers/withBreakpoint";
import { BrazeProvider } from "components/common/wrappers/withBraze";
import { PromoProvider } from "components/common/wrappers/withPromo";
import store from "state/store";

const basename = process.env.PUBLIC_URL;

export const GlobalProviders = ({ children }: PropsWithChildren) => {
  return (
    <Compose
      components={[
        { Component: Router, props: { basename } },
        { Component: ReduxProvider, props: { store } },
        { Component: PromoProvider, props: {} },
        { Component: TimerProvider, props: {} },
        { Component: PopupProvider, props: {} },
        { Component: BreakpointProvider, props: {} },
        { Component: BrazeProvider, props: {} },
        { Component: ChargebeeInstanceProvider, props: {} },
      ]}
    >
      {children}
    </Compose>
  );
};
